var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Field } from '../field/field.js';
import LocatorFieldAPI from './locator-field-api.js';
let LocatorField = class LocatorField extends Field {
};
LocatorField.propTypes = {
    ...Field.propTypes,
    hideLabel: Field.propTypes.hideLabel.notEnumerable(),
    validatedOnChange: Field.propTypes.validatedOnChange.notEnumerable(),
    validators: Field.propTypes.validators.notEnumerable(),
};
LocatorField.defaultProps = {
    ...Field.defaultProps,
    hideLabel: true,
};
LocatorField = __decorate([
    AwesomeComponent({ api: LocatorFieldAPI, type: ComponentType.FORM })
], LocatorField);
export default LocatorField;
//# sourceMappingURL=locator-field.js.map